export default "__VITE_ASSET__BwHF2M8p__"